import React from 'react';
import styles from './defaultLayout.module.scss';
import { Container, Header, Content } from 'rsuite';

interface DefaultLayoutProps {
  title: React.ReactNode;
  breadcrumb?: React.ReactNode;
  children: React.ReactNode;
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({
  title,
  breadcrumb,
  children,
}) => {
  return (
    <>
      {/* Assign the ref to the Container */}
      <Container className={styles.defaultLayout}>
        <Header className={styles['page-header']}>
          {title !== '' && (
            <h2 className={styles['defaultLayout--title']}>{title}</h2>
          )}
          {breadcrumb && breadcrumb !== '' && breadcrumb}
        </Header>
        <Content className={styles['defaultLayout--content']}>
          {children}
        </Content>
      </Container>
    </>
  );
};

export default DefaultLayout;
